// Tiny inline SVG sparkline. No axes, no labels — just a shape.
// Renders a smooth line + optional gradient fill. Handles all-zero series
// gracefully (draws a flat mid-line).
export default function Sparkline({ data, width = 120, height = 32, stroke = "#0f766e", fill = "#0f766e22" }) {
  if (!Array.isArray(data) || data.length < 2) {
    return <svg width={width} height={height} />;
  }
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data.map((v, i) => {
    const x = i * step;
    const y = height - 2 - ((v - min) / range) * (height - 4);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const path = "M " + points.join(" L ");
  const fillPath = `${path} L ${(data.length - 1) * step},${height} L 0,${height} Z`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <path d={fillPath} fill={fill} />
      <path d={path} stroke={stroke} strokeWidth={1.5} fill="none" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
